import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import pickBy from "lodash-es/pickBy";

// Configure request setup
const serviceName = 'NotificationService'
const host = servicesConfig.Notification
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const NotificationService = {
  getPreferences: (locationId: string, userId: string) => 
    request().get(`/preferences/locations/${locationId}/users/${userId}`).then(responseBody),
    
  savePreference: (locationId: string, userId: string, preferences: any) => 
    request().post(`/preferences`, {userId, locationId, preferences}).then(responseBody),

  getByUserIdAndLocations: (queryData: { [key: string]: any }) => {
    const bodyData = pickBy(queryData, v => v !== null && v !== undefined && v !== '')
    return request().post(`/`, bodyData).then(responseBody)
  },
  
  getByUserId: (userId: string, queryData: { [key: string]: any }) => {
    const params = pickBy(queryData, v => v !== null && v !== undefined && v !== '')
    return request().get(`/users/${userId}`, {params}).then(responseBody)
  },
  
  update: (id: string, data: { [key: string]: any }) => 
    request().put(`/${id}`, data).then(responseBody),

  updateByUserId: (userId: string, bodyData: { [key: string]: any }) => {
    const body = pickBy(bodyData, v => v !== null && v !== undefined && v !== '')
    return request().put(`/users/${userId}`, body).then(responseBody)
  },

  deleteByUserId: (userId: string) => 
    request().delete(`/users/${userId}`).then(responseBody)
}

export default NotificationService
